import '../styles/main.css';
import Trilho   from '../assets/HomePage/trilho-home.png'
import LogoFips from '../assets/HomePage/logo-fips-home.svg'
import iconUser from '../assets/HomePage/circle-user.svg';

import { UserContext } from '../contexts/UserContext.js'
import { useState, useContext, useEffect }      from 'react';


function HomePage() {

        const { userData }  = useContext(UserContext)

        const [fullName, setFullName] = useState(null)

        useEffect(()=>{ 
    
            if(!userData){ return }
    
            setFullName(userData.fullName) 
    
        }, [userData])
    
   
    return (
       
        <section className="flex flex-row overflow-hidden gap-[20%] h-screen w-screen font-['Saira']">

            <div className=' h-[100%] w-[100%] flex flex-col pl-[95px]'>

                <img className='pt-[35px] pl-[15px]' alt='Logo' width="190px" fill="black" src={LogoFips} />

                <p className='pt-[5%] pl-[16px] text-[#004B9B] font-bold text-[1.2rem] '>Sistema Alvorada</p>

                <div className='pt-[2%] pl-[15px] w-[300px]'>

                    <p className='text-[#004B9B] text-[2.8rem] font-bold leading-none'>O caminho que leva à excelência.</p>
                
                </div>

                <div className='pt-[25px] pl-[15px] w-[250px]'>

                    <p className='flex flex-end text-[#004B9B] text-[0.9rem]'>Acesse suas páginas através do menu lateral.</p>

                </div>


                <div className='fixed border-[solid] border-[1px] px-[15px] border-[#4f80c6] rounded-[15px]  min-h-[55px] max-h-[80px] text-center  bottom-[30px] flex flex-row items-center'>
                    
                    <img className="flex" width="20px" height="20px" fill="#658EC9" alt="Ícone Usuário" src={iconUser} />
                    <p className='pl-[8px] text-[#658EC9] text-[0.8rem] font-saira font-normal'>Olá, {fullName}</p>

                </div>

            </div>

            <div className=' h-[100%] w-[100%] right'>

                <img className="flex overflow-hidden" width="100%" height="100%" alt="Trilho" src={Trilho} fill="black"/>

            </div>
        </section>
    )
}


export default HomePage;